import React from 'react'
import Footer from '../component/Footer'
import Activities from '../Media/img/Medical Activities.png'

const MedicalActivitiesMedia = () => {
  return (
    <>
      <div className="headings">
        <h1>Medical Activities Media</h1>
      </div>


      <div style={{ width: '100%' }}>
        <img src={Activities} style={{ width: '100%' }} />
      </div>

      <Footer />
    </>
  )
}

export default MedicalActivitiesMedia


